import BaseIconSvg from '@/components/bases/BaseIconSvg';
import * as React from 'react';
import { ReactSVG } from 'react-svg';

export interface IBaseTitleIconProps {
  src?: string;
  title: string;
  type?: 'h1' | 'h3' | 'h1-yellow';
  className?: string;
  sub?: JSX.Element;
}

export default function BaseTitleIcon(props: IBaseTitleIconProps) {
  const { title, type = 'h3', className = '', sub, src = '' } = props;
  switch (type) {
    case 'h3':
      return (
        <div className={'flex mb-4 items-baseline mt-3 ' + className}>
          <BaseIconSvg.Yellow src={src} className="mr-2" />
          <div>
            <div className="cms-h3 uppercase">{title}</div>
          </div>
        </div>
      );
    // Đang làm dở

    case 'h1':
      return (
        <div className={'flex items-center ' + className}>
          <div className="bg-mint-8 rounded-xl wh-[64px] text-white mr-2 flex justify-center items-center flex-none">
            <BaseIconSvg src={src} className="wh-[32px]" />
          </div>
          <div>
            <div className="cms-page-title uppercase font-bold">{title}</div>
            {sub || ''}
          </div>
        </div>
      );
    case 'h1-yellow':
      return (
        <div className={'flex items-center ' + className}>
          <div className="phr-icon-btn-yellow rounded-xl wh-[64px] text-white mr-2 flex justify-center items-center flex-none">
            <BaseIconSvg src={src} className="wh-[32px]" />
          </div>
          <div className="flex w-full justify-start">
            <div className="cms-page-title uppercase font-bold">{title}</div>
          </div>
          <div className="flex w-full justify-end">{sub || ''}</div>
        </div>
      );
  }
}

export interface IBaseTitleSVGIconProps {
  icon: string;
  title: string;
  color?: string;
}

export function BaseTitleSVGIcon(props: IBaseTitleSVGIconProps) {
  return (
    <div className="flex mb-4 items-baseline mt-3">
      <div className="phr-icon-btn-yellow mr-2">
        <ReactSVG src={props.icon} style={{ color: props.color }} className="wh-[16px]" />
      </div>
      <div className="cms-h3 uppercase">{props.title}</div>
    </div>
  );
}
